import { UploadFile } from "@mui/icons-material";
import React, { Fragment, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Typography,
} from "@mui/material";

import { useAxios } from "../../../../hooks";
import { TextField, Label } from "../../../../components";
import { alert } from "../../../../redux/slices/alertSlice";

export default function AddSampleMedia({ formikProps }) {
  var extensions;
  const dispatch = useDispatch();
  const fileInputRef = useRef();
  const [uploading, setUploading] = useState(false);
  if (formikProps.values.templateHeader?.type === "image") {
    extensions = ".jpg, .jpeg, .jfif, .pjpeg, .pjp, .png, .svg, .webp,image/*";
  } else if (formikProps.values.templateHeader?.type === "video") {
    extensions = "video/mp4,video/x-m4v,video/*";
  } else {
    extensions = ".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf";
  }
  const x_sso_token = sessionStorage.getItem("ida_sso_login");
  const { accessToken, authToken } = useSelector(
    (state) => state.memberDetails
  );

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token ? authToken : "Bearer " + accessToken,
  });

  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploading(true);

      let base64String = await convertImageToBase64(file);

      if (
        ["image", "video", "document"].includes(
          formikProps.values.templateHeader?.type
        )
      ) {
        base64String = base64String.split(",")[1];
      }

      const response = await axios({
        url: "/wa/template/upload-media-v2",
        method: "POST",
        disableRedirect: true,
        data: {
          filename: file.name,
          content: base64String,
        },
      });

      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          templateHeader: {
            ...prev.templateHeader,
            example: [
              {
                url: response.data.media_url,
                timestamp: response.data.timestamp,
              },
            ],
          },
        }));

        dispatch(
          alert({
            type: "success",
            message: "File uploaded successfully",
          })
        );
      }
    } catch (error) {
      console.error(error);

      dispatch(
        alert({
          type: "error",
          message: "Failed to upload file",
        })
      );
    } finally {
      setUploading(false);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <React.Fragment>
      {Boolean(formikProps.values.templateHeader?.type) &&
        Boolean(formikProps.values.templateHeader?.count_of_variable !== 0) && (
          <Grid item xs={12}>
            <Typography variant="caption1">Header Variable</Typography>
          </Grid>
        )}

      {formikProps.values.templateHeader.type === "text" &&
        Boolean(formikProps.values.templateHeader.type) &&
        formikProps.values.templateHeader?.count_of_variable !== 0 &&
        Array(formikProps.values?.templateHeader?.count_of_variable)
          .fill()
          .map((_, index) => (
            <Fragment>
              <Grid item xs={4}>
                <Label
                  title={"Header Variable Value " + (index + 1)}
                  formikProps={formikProps}
                  required={true}
                  name={`templateHeader.example.header_text[${index}]`}
                />
              </Grid>

              <Grid key={index} item mt={1} xs={6}>
                <TextField
                  formikProps={formikProps}
                  disabled={
                    Boolean(formikProps.values.ID) || formikProps.isSubmitting
                  }
                  name={`templateHeader.example.header_text[${index}]`}
                />
              </Grid>
            </Fragment>
          ))}

      {formikProps.values.templateHeader.type !== "text" &&
        Boolean(formikProps.values.templateHeader.type) &&
        formikProps.values.templateHeader?.count_of_variable !== 0 && (
          <Fragment>
            <Grid item xs={4}>
              <Label
                title={"Header Variable Value "}
                formikProps={formikProps}
                required={true}
                name={"templateHeader.example"}
              />
            </Grid>

            <Grid item mt={1} xs={6}>
              <input
                type="file"
                hidden
                ref={fileInputRef}
                onChange={handleFileChange}
                accept={extensions}
                disabled={
                  Boolean(formikProps.values.ID) ||
                  formikProps.isSubmitting ||
                  uploading
                }
              />

              <TextField
                formikProps={formikProps}
                disabled={
                  Boolean(formikProps.values.ID) ||
                  formikProps.isSubmitting ||
                  uploading
                }
                name="templateHeader.example[0].url"
                label="Upload File"
                fullWidth
                placeholder={uploading ? "Uploading file..." : "Choose a file"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        onClick={handleClick}
                        edge="start"
                        disabled={uploading}
                      >
                        {uploading ? (
                          <CircularProgress size={22} />
                        ) : (
                          <UploadFile />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                  readOnly: true,
                }}
              />
            </Grid>
          </Fragment>
        )}
    </React.Fragment>
  );
}
